import React from 'react';

// components
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { MapContainer, TileLayer, Marker, useMap } from 'react-leaflet';
import L from 'leaflet'
import "../../../assets/css/map.css";

// style
import "../../../assets/css/modal-cellphone.css"

export default function ModalEnderecoMapa({ isOpen, handleReturn, position }) {

    const ChangeMap = ({ center, zoom }) => {
        const mapInstance = useMap();
        mapInstance.setView(center, zoom);
        return null;
    }

    return (
        <>
            <Modal isOpen={isOpen} toggle={handleReturn}>
                <ModalHeader>Mapa da Localização</ModalHeader>
                <ModalBody>
                    {position &&
                        <div id="map">
                            <MapContainer style={{ zIndex: "0", height: "60vh" }}>
                                <ChangeMap center={position} zoom={15}></ChangeMap>
                                <TileLayer
                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                />
                                <Marker position={position} icon={new L.Icon({ iconUrl: require('assets/img/icons/position.png'), iconRetinaUrl: require('assets/img/icons/position.png') })}></Marker>
                            </MapContainer>
                        </div>
                    }
                </ModalBody>
                <ModalFooter>
                    <Button color="default" onClick={handleReturn}>Fechar</Button>
                </ModalFooter>
            </Modal>
        </>
    );
}

